module.exports = __webpack_public_path__ + "static/media/sketch-background.d5da1712.jpg";